module.exports = __webpack_public_path__ + "static/media/Brunnen.59e09df9.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Brunnen.JPG
// module id = 757
// module chunks = 0